import { useTheme } from "@mui/material";
import { useScreenWidth } from "hooks/useScreenWidth";
import { useMemo } from "react";

import { brandColors } from "../util";

export function EnvBar() {
  const theme = useTheme();
  const { screenMaxWidth } = useScreenWidth();

  const viteEnvRaw = String(import.meta.env.VITE_ENV || "");
  const viteEnv = viteEnvRaw.toLowerCase();
  const suffix = String(import.meta.env.VITE_ENV_BAR_SUFFIX || "");
  const envBarBackgroundColor = String(import.meta.env.VITE_ENV_BAR_BG || "");
  const envBarForegroundColor = String(import.meta.env.VITE_ENV_BAR_FG || "");
  const colors = useMemo(() => {
    let base: string;
    switch (viteEnv) {
      case "release":
        base = brandColors["encamp-orange"][theme.palette.mode === "dark" ? 600 : 400];
        break;
      case "demo":
        base = brandColors["encamp-blue"][theme.palette.mode === "dark" ? 700 : 200];
        break;
      case "dev":
        base = brandColors["encamp-green"][theme.palette.mode === "dark" ? 800 : 400];
        break;
      default:
        base = brandColors["encamp-purple"][theme.palette.mode === "dark" ? 700 : 300];
        break;
    }
    return {
      bg: envBarBackgroundColor || base,
      fg: envBarForegroundColor || undefined,
      base,
    };
  }, [viteEnv, theme.palette.mode, envBarBackgroundColor, envBarForegroundColor]);

  const label = viteEnvRaw ? viteEnvRaw.charAt(0).toUpperCase() + viteEnvRaw.slice(1) : "Unknown";

  return (
    <div
      style={{
        borderTop: `5px solid ${colors.bg}`,
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1,
        pointerEvents: "none",
      }}
    >
      <div style={{ maxWidth: screenMaxWidth, position: "relative" }}>
        <div
          id="env-display"
          style={{
            backgroundColor: colors.bg,
            color: colors.fg,
            borderRadius: "0 0 6px 6px",
            position: "absolute",
            right: 24,
            top: -5,
            fontSize: "0.8rem",
            padding: "1px 0.5rem",
            width: "fit-content",
            lineHeight: ".8",
            minWidth: "150px",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          <span style={{ opacity: 0.9 }}>{suffix ? `${label} — ${suffix}` : label}</span>
        </div>
      </div>
    </div>
  );
}
